import * as React from "react";
import { Model } from "@flowable/forms";
import Icon from "@cayuse/shared-react.components.icon";
import styles from "./styles.css";
import { Table } from "semantic-ui-react";
import moment from "moment";

class SelectedRateTypeTable extends Model.StatefulFormComponent {
	state = {
		touched: true,
		formValid: true,
		loading: false,
		value: null,
		rateOrder: {}
	};

	async componentDidMount () {
		this.onDateRangeChange();
	}

	onDateRangeChange () {
		this.generateRateOrder();
	}

	generateRateOrder () {
		const dateRanges = this.getRateDateRanges();
		if (dateRanges && dateRanges.length > 0 && dateRanges[0]?.rates) {
			let nextIndex = 2;
			const rateOrder = {};
			const rates = dateRanges[0]?.rates;
			for (let rate of rates) {
				if (rate?.categoryName === "On Campus") {
					rateOrder[rate?.categoryId] = 0;
				} else if (rate?.categoryName === "Off Campus") {
					rateOrder[rate?.categoryId] = 1;
				} else {
					rateOrder[rate?.categoryId] = nextIndex;
					nextIndex++;
				}
			}
			this.setState({ ...this.state, rateOrder });
		}
	}

	componentDidUpdate (prevProps, prevState, snapshot) {
		if (prevProps?.config?.rateDateRanges?.length !== this.props?.config?.rateDateRanges?.length) {
			this.onDateRangeChange();
		}
	}

	shouldComponentUpdate (nextProps, nextState) {
		return Object.keys(nextState.rateOrder).length !== Object.keys(this.state.rateOrder).length ||
			nextProps?.config?.rateDateRanges?.length !== this.props?.config?.rateDateRanges?.length;
	}

	getRateDateRanges () {
		return this.props?.config?.rateDateRanges;
	}

	hasDateRanges () {
		const dateRanges = this.getRateDateRanges();

		return dateRanges && dateRanges.length > 0 && dateRanges[0]?.rates;
	}

	render () {
		const { Components } = this.props;
		const { loading } = this.state;

		const dateRanges = this.getRateDateRanges();

		return loading ?
			(<div>Loading...</div>)
			: (
				<div className={styles.componentMargin}>
					<Components.description {...this.props}/>
					<label className={styles.heading}>Selected Rate Type Table</label>
					<Table className={styles.table}>
						<caption>Selected Rate Type</caption>
						<Table.Header>
							{this.renderHeaderRow()}
						</Table.Header>
						<Table.Body>
							{dateRanges?.map((row, index) => this.renderRow(row, index))}
							{!dateRanges && (
								<Table.Row>
									<Table.Cell className={styles.noRates} colSpan={3}>
										No rate type has been selected
									</Table.Cell>
								</Table.Row>
							)}
						</Table.Body>
					</Table>
				</div>
			);
	}

	renderHeaderRow () {
		const dateRanges = this.getRateDateRanges();
		if (!this.hasDateRanges()) {
			return (
				<Table.Row key="headerRow">
					<Table.HeaderCell className={styles.tableHeaderItem}>Type</Table.HeaderCell>
					<Table.HeaderCell className={styles.tableHeaderItem}>On Campus</Table.HeaderCell>
					<Table.HeaderCell className={styles.tableHeaderItem}>Off Campus</Table.HeaderCell>
				</Table.Row>
			);
		}
		const rates = this.deepCopy(dateRanges[0]?.rates);
		const rateOrder = this.state.rateOrder;
		let headerCells = [];
		for (let i = 0; i < rates.length; i++) {
			const rate = rates[i];
			const providedOrder = rateOrder[rate?.categoryId];
			if (providedOrder === 0 || providedOrder) {
				headerCells[providedOrder] = (
					<Table.HeaderCell key={i} className={styles.tableHeaderItem}>
						{rate?.categoryName || "--"}
					</Table.HeaderCell>
				);
			}
		}

		return (
			<Table.Row key="headerRow">
				<Table.HeaderCell className={styles.tableHeaderItem}>Type</Table.HeaderCell>
				{headerCells}
			</Table.Row>
		);
	}

	renderRow (row, index) {
		const formattedStartDate = SelectedRateTypeTable.formatDate(row?.startDate);
		const formattedEndDate = SelectedRateTypeTable.formatDate(row?.endDate);

		return (
			<Table.Row key={index}>
				<Table.Cell>
					<div className={styles.dateRangeWrapper}>
						<div className={styles.dateWrapper}>
							<Icon
								name="calendar"
								size="bigger"
							/>
							{formattedStartDate || "--"}
						</div>
						<div className={styles.dateToWrapper}>
							<div className={styles.dateToDivider}/>
						</div>
						<div className={styles.dateWrapper}>
							<Icon
								name="calendar"
								size="bigger"
							/>
							{formattedEndDate || "--"}
						</div>
					</div>
				</Table.Cell>
				{row?.rates?.map((rate, index) => this.renderRate(rate, index))}
			</Table.Row>


		);
	}

	renderRate (rate, index) {
		let rateText = "--";
		if (rate?.percent) {
			rateText = `${rate.percent.toFixed(2)}%`;
		}

		return (<Table.Cell key={index}>{rateText}</Table.Cell>);
	}

	static formatDate (dateString) {
		return moment(dateString).format("MM/DD/YYYY");
	}

	static isPresent (value) {
		return value !== undefined && value !== null && value !== "";
	}

	deepCopy (value) {
		return JSON.parse(JSON.stringify(value));
	}
}

export default SelectedRateTypeTable;
